import { SupportedLocale } from 'shared'

import enTranslations from './locales/en/translation.json'
import esMxTranslations from './locales/es/translation.json'

export const I18N_FALLBACK_LOCALE = SupportedLocale.EN
export const I18N_SUPPORTED_LOCALES = [SupportedLocale.EN, SupportedLocale.ES_MX]

export const i18nResources = {
  en: { translation: enTranslations },
  es: { translation: esMxTranslations },
  [SupportedLocale.ES_MX]: { translation: esMxTranslations },
} as const

export { enTranslations, esMxTranslations }
